<template>
  <v-row>
    <v-dialog v-model="trackCodeDialog" persistent max-width="600px">      
      <v-card>
          <v-card-title>
            <span class="headline">Enviar código de Rastramento</span>
          </v-card-title>          
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation              
            >
          <v-card-text>
            <v-container grid-list-md>
              <v-row>
                <v-col xs="12">
                  <v-text-field :autofocus="true" :rules="trackCodeRules" required v-model="track_code" label="Código de Rastreamento*"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeModal">Fechar</v-btn>
            <v-btn :disabled="!valid" color="blue darken-1" text @click="sendTrackCode">Enviar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios';
  export default {
    data () {
      return {        
        track_code: '',
        valid: false,
        loading: false,
        snackbar: {},
        trackCodeRules: [v => !!v || 'Código de Rastreamento é obrigatório',]
      }
    },
    computed: {
      trackCodeDialog () {
        return this.$store.state.trackCodeDialog
      }
    },
    methods: {
      closeModal () {
        this.$store.dispatch('setTrackCodeDialog', false)
      },
      sendTrackCode() {
        const {track_code} = this;
        const transaction = this.$store.state.selectedTransaction;        
        const payload = {
          data: {
            track_code,
            constumer_name: transaction.customer.name,
            customer_postal_code: transaction.customer.address.postal_code,
            customer_email: transaction.customer.email,
            store_name: transaction.store.name,
            transaction_id: transaction.platform_id,
          }
        };
        this.$store.dispatch('sendTrackCode', payload);
      }
    },    
  }
</script>

<style lang="css" scoped>
  .v-progress-circular {
    margin: 30px;
  }
</style>